import type { PortfolioCard } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { PortfolioCaseCard } from '@/entities/portfolio';
import { cn } from '@/shared/ui';

/** 맨 앞 카드를 두 칸·두 줄 큰 카드로 키우는 최소 카드 수 — 큰 카드 오른쪽 두 칸을 채울 수 있어야 한다. */
const FEATURED_MIN_COUNT = 3;

interface PortfolioCardGridProps {
  readonly items: readonly PortfolioCard[];
  /** 첫 페이지에서만 맨 앞 사례를 크게 세운다 — 다음 페이지는 고른 격자. */
  readonly featureFirst: boolean;
  readonly onRetry: () => void;
}

/**
 * 포트폴리오 카드 격자(모바일 1열·sm 2열·lg 3열).
 * 큰 카드는 sm 에서 두 칸 전폭, lg 에서 두 칸·두 줄을 차지하고 오른쪽에 다음 두 장이 세로로 선다.
 */
export const PortfolioCardGrid = ({
  items,
  featureFirst,
  onRetry,
}: PortfolioCardGridProps): ReactElement => {
  const hasFeatured = featureFirst && items.length >= FEATURED_MIN_COUNT;
  return (
    <ul className="grid grid-cols-1 gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((item, index) => {
        const isFeatured = hasFeatured && index === 0;
        return (
          <li
            key={item.id}
            data-featured={isFeatured ? 'true' : undefined}
            className={cn('min-w-0', isFeatured && 'sm:col-span-2 lg:row-span-2')}
          >
            <PortfolioCaseCard item={item} isFeatured={isFeatured} onRetry={onRetry} />
          </li>
        );
      })}
    </ul>
  );
};
